<ng-template #fixFareModal let-modal>
    <div class="modal-content">
        <div class="modal-body">
            <div class="m-3">
                <div class="referral">
                    <h4 class="mb-3">{{ "heading-title.fixed-rate-available" | translate }}</h4>
                    <p class="text-muted mb-3">
                        {{ "label-title.fix-fare-description" | translate }}
                    </p>
                </div>
                <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                    <button type="button" class="btn w-sm btn-secondary" (click)="onSubmit(true)">{{ "button-title.yes"
                        | translate }}</button>
                    <button type="button" class="btn w-sm btn-outline-secondary" (click)="onSubmit(false)">{{
                        "button-title.no" | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>